import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Listing } from './listing.component';
import { AvatarModule } from '../avatar/avatar.module';
import { DonutModule } from '../donut/donut.module';

@NgModule({
  declarations: [
    Listing
  ],
  imports: [
    CommonModule,
    AvatarModule,
    DonutModule
  ],
  exports: [
    Listing
  ]
})
export class ListingModule { }
